"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes/CustomPropTypes"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _listOfIcons = require("../utils/listOfIcons");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _icon = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/icon.css") : void 0);

var _infoLabel = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/info-label.css") : void 0);

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source), true)).call(_context2, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _objectSpread(_objectSpread({}, _icon.default), _infoLabel.default));
/** An **InfoLabel** is a small non-interactive numeric or text-based control.
 * Its primary use is to add user-defined characteristic to an object. */

var InfoLabel = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _context, _classnames;

  var children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      cssNamespace = _ref.cssNamespace,
      glyph = _ref.glyph,
      numeric = _ref.numeric,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "className", "color", "cssNamespace", "glyph", "numeric"]);
  var labelClasses = classnames("".concat(cssNamespace, "-info-label"), (_classnames = {}, (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-info-label--numeric"), numeric), (0, _defineProperty2.default)(_classnames, (0, _concat.default)(_context = "".concat(cssNamespace, "-info-label--accent-color-")).call(_context, color), color), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-info-label--icon"), glyph), _classnames), className);
  return /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({}, props, {
    className: labelClasses,
    ref: ref
  }), glyph && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    ariaHidden: true,
    className: classnames('fd-info-label__icon'),
    glyph: glyph
  }), children && /*#__PURE__*/_react.default.createElement("span", {
    className: classnames('fd-info-label__text')
  }, children));
});

InfoLabel.displayName = 'InfoLabel';
process.env.NODE_ENV !== "production" ? InfoLabel.propTypes = {
  /** Node(s) to render within the component */
  children: _propTypes.default.node,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** In addition the the default grey, there are additional Semantic color options */
  color: _CustomPropTypes.default.range(1, 10),

  /** See Icon component for list of icon options */
  glyph: _propTypes.default.oneOf(_listOfIcons.listOfIcons),

  /** Set to **true** if using the label for only a numeric value */
  numeric: _propTypes.default.bool
} : void 0;

var _default = (0, _withStyles.default)(InfoLabel);

exports.default = _default;